export const ArrowDown = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.88963 8.72594L6.63683 7.97874L6.63673 7.97865L9.99904 4.61634L9.25184 3.86914L5.88953 7.23145L2.52723 3.86914L1.78003 4.61634L5.14233 7.97865L5.14224 7.97874L5.88944 8.72594L5.88953 8.72585L5.88963 8.72594Z"
        fill="#DDDDDD"
      />
    </svg>
  );
};
